import {
    NgModule
} from '@angular/core';
import {
    IonicModule
} from '@ionic/angular';
import {
    ExportedClass as ShowLoginPassword
} from './custom/ShowLoginPassword';
@NgModule({
    declarations: [
        ShowLoginPassword,
    ],
    imports: [IonicModule],
    exports: [
        ShowLoginPassword,
    ]
})
export class DirectivesModule {}